import React from 'react';
import { Button, Spinner } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import useResendEmailPanelState from '../Utils/useResendEmailPanelState';

function ResendEmailPanel(): React.JSX.Element {
    const { resendHandler, resendButtonLoading } = useResendEmailPanelState();

    return (
        <div className="flex flex-col items-start p-2">
            <p className="text-sm">{UIStrings.DontSeeEmailInSpamJunkFolder}</p>
            <Button
                type="button"
                variant="default"
                size="sm"
                className="h-8"
                onClick={resendHandler}
                disabled={resendButtonLoading}
            >
                {resendButtonLoading && <Spinner data-icon="inline-start" className="animate-spin" />}
                {UIStrings.ResendEmail}
            </Button>
        </div>
    );
}

export default ResendEmailPanel;
